import { render, staticRenderFns } from "./DrawerCustomiseCoverSpecifiedItems.vue?vue&type=template&id=7789e768&scoped=true&"
import script from "./DrawerCustomiseCoverSpecifiedItems.vue?vue&type=script&lang=js&"
export * from "./DrawerCustomiseCoverSpecifiedItems.vue?vue&type=script&lang=js&"
import style0 from "./DrawerCustomiseCoverSpecifiedItems.vue?vue&type=style&index=0&id=7789e768&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7789e768",
  null
  
)

export default component.exports